module.exports = __webpack_public_path__ + "img/l_h4.16609d9c.png";